import { apiRoutes } from 'config/apiRoutes'
import { useQuery } from 'libs/query'
import { useAxiosPrivate } from 'shared/hooks'
import type { AreaTypesRes } from 'features/areaTypes/types/areaTypes.types'
import { useContext } from 'react'
import { AuthContext } from 'store'
import { queryKeys } from 'config/queryKeys'
import { getCurrentQuery } from 'utils/getCurrentQuery'

export const useFetchAreaTypes = () => {
	const axiosPrivate = useAxiosPrivate()
	const { auth } = useContext(AuthContext)
	const query = getCurrentQuery()

	const {
		data: boothTypes,
		isPending: isAreaTypesLoading,
		isSuccess: isAreaTypesSuccess
	} = useQuery<AreaTypesRes>({
		queryKey: queryKeys.boothTypes.list(query),
		queryFn: () => axiosPrivate.get(apiRoutes.areaTypes(query)),
		enabled: !!auth.accessToken
	})

	return {
		boothTypes,
		isAreaTypesLoading,
		isAreaTypesSuccess
	}
}
